import {css, StyleSheet} from "aphrodite";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {Spring} from "@khanacademy/wonder-blocks-layout";
import {color} from "@khanacademy/wonder-blocks-tokens";
import {Body} from "@khanacademy/wonder-blocks-typography";
import {mediaQueries} from "@repo/shared-styles";
import {staticUrl} from "@repo/urls";

type Props = {
    header: string;
    text: string;
    imgAltText: string;
    imgPath: string;
    imgHeight: number;
};

export default class LoveToLearnBullet extends React.Component<Props> {
    render(): React.ReactNode {
        const {header, text, imgAltText, imgPath, imgHeight} = this.props;

        return (
            <View style={bulletStyles.container}>
                <View style={bulletStyles.imageContainer}>
                    <Spring />
                    <img
                        className={css(bulletStyles.image)}
                        height={imgHeight}
                        alt={imgAltText}
                        src={staticUrl(imgPath)}
                    />
                    <Spring />
                </View>
                <View>
                    <h4 className={css(bulletStyles.header)}>{header}</h4>
                    <Body style={bulletStyles.body}>{text}</Body>
                </View>
            </View>
        );
    }
}

const bulletStyles = StyleSheet.create({
    container: {
        flexDirection: "row",
        marginBottom: 18,

        [mediaQueries.smOrSmaller]: {
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            flexDirection: "column",
        },
    },

    imageContainer: {
        flexDirection: "row",
        paddingRight: 35,
        maxWidth: 95,
        minWidth: 95,

        [mediaQueries.smOrSmaller]: {
            maxWidth: 60,
            minWidth: 60,
            marginBottom: 21,
            padding: 0,
        },
    },

    image: {
        width: "auto",
        marginTop: 25,
        marginLeft: "auto",
        marginRight: "auto",

        [mediaQueries.smOrSmaller]: {
            marginTop: 0,
        },
    },

    header: {
        margin: 0,
        fontSize: 21,
        lineHeight: 1.52,
        fontWeight: "bold",
        whiteSpace: "nowrap",

        [mediaQueries.smOrSmaller]: {
            whiteSpace: "normal",
            fontSize: 19,
            lineHeight: 1.68,
        },
    },

    body: {
        color: color.offBlack64,
        fontSize: 18,
        lineHeight: 1.33,
        marginBottom: 10,
        marginTop: 8,

        [mediaQueries.mdOrSmaller]: {
            fontSize: 15,
            lineHeight: 1.53,
        },

        [mediaQueries.smOrSmaller]: {
            maxWidth: 212,
            marginBottom: 60,
        },
    },
});
